document.addEventListener('DOMContentLoaded', function() {
  const glides = document.querySelectorAll('.glide:not(.glide--timeline)');
  for (const glide of glides) {
    const totalSlide = glide.querySelectorAll('.glide__slide').length;
    const glideSlider = new Glide(glide, {
      type: 'carousel',
      autoplay: glide.getAttribute('data-auto-rotate') === 'false' ? false : glide.getAttribute('data-auto-rotate') ,
      perView: glide.getAttribute('data-slide-per-view'),
      focusAt: 'center',
      gap: 20,
      breakpoints: {
        989: {
          perView: 1
        },
      }
    });
    if (glide.querySelector('.glide__counter')) {
        glideSlider.on(['mount.after', 'run'], function () {
        glide.querySelector('.glide__counter').innerHTML = `${glideSlider.index + 1} / ${totalSlide}`;
      })
    }

    scrollGlideSliderHeadings(glideSlider);
    
    glideSlider.mount();
  }

  const glidesTimeline = document.querySelectorAll('.glide--timeline.glide--timeline-text');
  for (const glide of glidesTimeline) {
    const totalSlide = glide.querySelectorAll('.glide__slide').length;
    const glideSliderSectionId = glide.closest('.shopify-section').getAttribute('id');
    const glideSliderImages = new Glide(`#${glideSliderSectionId} .glide--timeline-images`, {
      type: 'slider',
      autoplay: glide.getAttribute('data-auto-rotate') === 'false' ? false : glide.getAttribute('data-auto-rotate') ,
      rewind: false,
      perView: glide.getAttribute('data-slide-per-view'),
      gap: 20,
      breakpoints: {
        989: {
          peek: {
            before: 0,
            after: 50
          }
        },
      }
    });
    const glideSliderText = new Glide(`#${glideSliderSectionId} .glide--timeline-text`, {
      type: 'slider',
      autoplay: glide.getAttribute('data-auto-rotate') === 'false' ? false : glide.getAttribute('data-auto-rotate') ,
      rewind: false,
      perView: glide.getAttribute('data-slide-per-view'),
      gap: 20
    });

    scrollGlideSliderHeadings(glideSliderText);
  
    glideSliderImages.mount();
    glideSliderText.mount();
    
    syncGlideSlider(glideSliderImages, glideSliderText);
    syncGlideSlider(glideSliderText, glideSliderImages);
  }
});

function syncGlideSlider(master, slave) {
  master.on("run", function (e) {
    if (e.direction === '=') {
      slave.go(`${e.direction}${e.steps}`);
    } else {
      slave.go(e.direction);
    }
  });
}

function scrollGlideSliderHeadings(slider) {
  slider.on("run", function (e) {
    let sliderHeadings = [];
    if (typeof slider.selector == 'string') {
      sliderHeadings = document.querySelector(slider.selector).querySelectorAll('.glide__slide-headings button');
    } else {
      sliderHeadings = slider.selector.querySelectorAll('.glide__slide-headings button');
    }
    if (sliderHeadings.length) {
      sliderHeadings[slider.index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
}